import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'cb-view-image',
    templateUrl: './view-image.component.html',
    styleUrls: ['./view-image.component.scss'],
    standalone: false
})
export class ViewImageComponent {
    public static readonly MIN_WIDTH = '400px';

    constructor(
        public readonly dialogRef: MatDialogRef<ViewImageComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,) { }
}
